// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/gel-bootstrap-3/dist/css/gray-light-gel.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Less is a CSS pre-processor: http://lesscss.org/ */
/* Legal Billing Report */
.billing-nav {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  border-bottom: 2px solid #ddd;
}
.billing-nav li {
  margin: 0;
}
.billing-nav a {
  display: block;
  padding: 8px 20px;
  text-decoration: none;
  color: #555;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
}
.billing-nav a:hover {
  color: #1565c0;
}
.billing-nav .billing-nav-active a {
  color: #1565c0;
  border-bottom-color: #1565c0;
}
.billing-report-page {
  padding: 20px;
  font-family: 'Roboto', Arial, sans-serif;
}
.billing-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  align-items: flex-end;
}
.billing-filter-group {
  display: flex;
  flex-direction: column;
}
.billing-filter-group label {
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 13px;
}
.billing-select {
  width: 220px;
}
.billing-report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 12px 0;
  border-bottom: 2px solid #333;
}
.billing-header-left {
  flex: 0 0 auto;
}
.billing-logo {
  height: 40px;
}
.billing-header-center {
  flex: 1 1 auto;
  text-align: center;
}
.billing-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.billing-practice-area-name {
  font-size: 16px;
  font-weight: 600;
  color: #1565c0;
}
.billing-header-right {
  flex: 0 0 auto;
  text-align: right;
}
.billing-date {
  font-size: 13px;
  color: #555;
}
.billing-last-processed {
  font-size: 12px;
  color: #555;
  font-style: italic;
}
.billing-loading {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #666;
}
.billing-loading .fa {
  margin-right: 8px;
}
.billing-error {
  text-align: center;
  padding: 20px;
  color: #c62828;
  font-weight: 600;
}
.billing-no-data {
  text-align: center;
  padding: 40px;
  color: #777;
  font-size: 14px;
}
.billing-table-wrapper {
  overflow-x: auto;
  margin-bottom: 40px;
}
.billing-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
}
.billing-table th,
.billing-table td {
  border: 1px solid #ccc;
  padding: 4px 8px;
}
.billing-table thead th {
  background: #2c3e50;
  color: #fff;
  font-weight: 600;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 1;
}
.billing-table .billing-cell-category {
  font-weight: 600;
  vertical-align: top;
  background: #f5f5f5;
  text-align: left;
  min-width: 120px;
}
.billing-table .billing-cell-id {
  vertical-align: top;
  text-align: left;
  min-width: 80px;
}
.billing-table .billing-cell-name {
  vertical-align: top;
  text-align: left;
  min-width: 200px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.billing-table .billing-cell-label {
  font-weight: 600;
  text-align: left;
  min-width: 60px;
}
.billing-table .billing-label-variance {
  font-style: italic;
}
.billing-table .billing-cell-amount {
  text-align: right;
  font-variant-numeric: tabular-nums;
  min-width: 70px;
}
.billing-table .billing-negative {
  color: #c62828;
  font-weight: 600;
}
.billing-table .billing-alt-group {
  background: #fafafa;
}
.billing-table .billing-row-variance td {
  border-bottom-width: 2px;
  border-bottom-color: #aaa;
}
.billing-table .billing-cell-practice-area {
  font-weight: 600;
  text-align: left;
  min-width: 180px;
  background: #e8edf2;
}
.billing-table .billing-cell-year-total {
  font-weight: 600;
  background: #f0f4f8;
}
.billing-table .billing-indent {
  padding-left: 24px;
}
.billing-table .billing-row-pa-header td {
  border-bottom: none;
}
@media print {
  .no-print {
    display: none !important;
  }
  .navbar {
    display: none !important;
  }
  .billing-report-page {
    padding: 0;
  }
  .billing-table-wrapper {
    overflow: visible;
  }
  .billing-table {
    font-size: 10px;
  }
  .billing-table th,
  .billing-table td {
    padding: 2px 4px;
  }
  .billing-row-variance {
    page-break-after: auto;
  }
  .billing-cell-category {
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.less"],"names":[],"mappings":"AAAA,qDAAqD;AAErD,yBAAyB;AAEzB;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;AAAF;AALA;EAQI,SAAA;AAAJ;AARA;EAYI,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,2CAAA;AADJ;AAGI;EACE,cAAA;AADN;AAtBA;EA4BI,cAAA;EACA,4BAAA;AAHJ;AAOA;EACE,aAAA;EACA,wCAAA;AALF;AAQA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;AANF;AASA;EACE,aAAA;EACA,sBAAA;AAPF;AAKA;EAKI,gBAAA;EACA,kBAAA;EACA,eAAA;AAPJ;AAWA;EACE,YAAA;AATF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAVF;AAaA;EACE,cAAA;AAXF;AAcA;EACE,YAAA;AAZF;AAeA;EACE,cAAA;EACA,kBAAA;AAbF;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAdF;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAfF;AAkBA;EACE,cAAA;EACA,iBAAA;AAhBF;AAmBA;EACE,eAAA;EACA,WAAA;AAjBF;AAoBA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAlBF;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAnBF;AAeA;EAOI,iBAAA;AAnBJ;AAuBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AArBF;AAwBA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAtBF;AAyBA;EACE,gBAAA;EACA,mBAAA;AAvBF;AA0BA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAxBF;AAoBA;;EAOI,sBAAA;EACA,gBAAA;AAvBJ;AAeA;EAYI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAxBJ;AAMA;EAsBI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAzBJ;AADA;EA8BI,mBAAA;EACA,gBAAA;EACA,eAAA;AA1BJ;AANA;EAoCI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA3BJ;AAdA;EA6CI,gBAAA;EACA,gBAAA;EACA,eAAA;AA5BJ;AAnBA;EAmDI,kBAAA;AA7BJ;AAtBA;EAuDI,iBAAA;EACA,kCAAA;EACA,eAAA;AA9BJ;AA3BA;EA6DI,cAAA;EACA,gBAAA;AA/BJ;AA/BA;EAkEI,mBAAA;AAhCJ;AAlCA;EAsEI,wBAAA;EACA,yBAAA;AAjCJ;AAtCA;EA2EI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlCJ;AA5CA;EAkFI,gBAAA;EACA,mBAAA;AAnCJ;AAhDA;EAuFI,kBAAA;AApCJ;AAnDA;EA2FI,mBAAA;AArCJ;AAyCA;EACE;IACE,wBAAA;EAvCF;EA0CA;IACE,wBAAA;EAxCF;EA2CA;IACE,UAAA;EAzCF;EA4CA;IACE,iBAAA;EA1CF;EA6CA;IACE,eAAA;EA3CF;EA0CA;;IAII,gBAAA;EA1CJ;EA8CA;IACE,sBAAA;EA5CF;EA+CA;IACE,wBAAA;EA7CF;AACF","sourcesContent":["/* Less is a CSS pre-processor: http://lesscss.org/ */\n@import \"~gel-bootstrap-3/dist/css/gray-light-gel.min.css\";\n\n/* Legal Billing Report */\n.billing-nav {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 16px 0;\n  border-bottom: 2px solid #ddd;\n\n  li {\n    margin: 0;\n  }\n\n  a {\n    display: block;\n    padding: 8px 20px;\n    text-decoration: none;\n    color: #555;\n    font-weight: 600;\n    font-size: 14px;\n    border-bottom: 3px solid transparent;\n    margin-bottom: -2px;\n    transition: color 0.15s, border-color 0.15s;\n\n    &:hover {\n      color: #1565c0;\n    }\n  }\n\n  .billing-nav-active a {\n    color: #1565c0;\n    border-bottom-color: #1565c0;\n  }\n}\n\n.billing-report-page {\n  padding: 20px;\n  font-family: 'Roboto', Arial, sans-serif;\n}\n\n.billing-filters {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  align-items: flex-end;\n}\n\n.billing-filter-group {\n  display: flex;\n  flex-direction: column;\n\n  label {\n    font-weight: 600;\n    margin-bottom: 4px;\n    font-size: 13px;\n  }\n}\n\n.billing-select {\n  width: 220px;\n}\n\n.billing-report-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 12px 0;\n  border-bottom: 2px solid #333;\n}\n\n.billing-header-left {\n  flex: 0 0 auto;\n}\n\n.billing-logo {\n  height: 40px;\n}\n\n.billing-header-center {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.billing-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n}\n\n.billing-practice-area-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1565c0;\n}\n\n.billing-header-right {\n  flex: 0 0 auto;\n  text-align: right;\n}\n\n.billing-date {\n  font-size: 13px;\n  color: #555;\n}\n\n.billing-last-processed {\n  font-size: 12px;\n  color: #555;\n  font-style: italic;\n}\n\n.billing-loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 16px;\n  color: #666;\n\n  .fa {\n    margin-right: 8px;\n  }\n}\n\n.billing-error {\n  text-align: center;\n  padding: 20px;\n  color: #c62828;\n  font-weight: 600;\n}\n\n.billing-no-data {\n  text-align: center;\n  padding: 40px;\n  color: #777;\n  font-size: 14px;\n}\n\n.billing-table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 40px;\n}\n\n.billing-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  white-space: nowrap;\n\n  th, td {\n    border: 1px solid #ccc;\n    padding: 4px 8px;\n  }\n\n  thead th {\n    background: #2c3e50;\n    color: #fff;\n    font-weight: 600;\n    text-align: center;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  .billing-cell-category {\n    font-weight: 600;\n    vertical-align: top;\n    background: #f5f5f5;\n    text-align: left;\n    min-width: 120px;\n  }\n\n  .billing-cell-id {\n    vertical-align: top;\n    text-align: left;\n    min-width: 80px;\n  }\n\n  .billing-cell-name {\n    vertical-align: top;\n    text-align: left;\n    min-width: 200px;\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .billing-cell-label {\n    font-weight: 600;\n    text-align: left;\n    min-width: 60px;\n  }\n\n  .billing-label-variance {\n    font-style: italic;\n  }\n\n  .billing-cell-amount {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    min-width: 70px;\n  }\n\n  .billing-negative {\n    color: #c62828;\n    font-weight: 600;\n  }\n\n  .billing-alt-group {\n    background: #fafafa;\n  }\n\n  .billing-row-variance td {\n    border-bottom-width: 2px;\n    border-bottom-color: #aaa;\n  }\n\n  .billing-cell-practice-area {\n    font-weight: 600;\n    text-align: left;\n    min-width: 180px;\n    background: #e8edf2;\n  }\n\n  .billing-cell-year-total {\n    font-weight: 600;\n    background: #f0f4f8;\n  }\n\n  .billing-indent {\n    padding-left: 24px;\n  }\n\n  .billing-row-pa-header td {\n    border-bottom: none;\n  }\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .navbar {\n    display: none !important;\n  }\n\n  .billing-report-page {\n    padding: 0;\n  }\n\n  .billing-table-wrapper {\n    overflow: visible;\n  }\n\n  .billing-table {\n    font-size: 10px;\n\n    th, td {\n      padding: 2px 4px;\n    }\n  }\n\n  .billing-row-variance {\n    page-break-after: auto;\n  }\n\n  .billing-cell-category {\n    page-break-inside: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
